export const ERROR = {
  BASE: "Error",
  TOKEN_EXPIRED: "Your token is expired. Please login again!",
  INVALID_TOKEN: "Invalid token",
  NETWORK: "Networking problem",
};
